<template>
	<div class="history-contact-container">
		<div class="history-contact-tab">
			<span :class="{'history-contact-tab-active':activeTab == 'fans'}" @click="tabClick('fans')">好友列表</span>
			<span :class="{'history-contact-tab-active':activeTab == 'cluster'}" @click="tabClick('cluster')">群列表</span>
		</div>
		<div class="history-contact-search">
			<div class="history-contact-search-input">
				<input type="text" placeholder="请输入昵称/群名称" v-model="keyword">
				<span class="history-contact-search-icon"></span>
			</div>
		</div>
		<div class="history-contact-list" @scroll="contactScroll" id="history-contact-list">
			<div class="history-contact-item" v-for="contact in contactList" 
				:key="'history-c-'+contact.pageType+'-'+contact.id" 
				:class="{'history-contact-item-active':currentContact.id == contact.id}"
				@click="contactClick(contact)" >
				<div class="history-contact-avatar">
					<img :src="contact.wx_photo !== undefined ? contact.wx_photo : contact.cluster_photo | connectHost" alt="">
				</div>
				<div class="history-contact-info">
					<p class="history-contact-name">{{contact.wx_name !== undefined ? contact.wx_name : contact.cluster_name}}</p>
				</div>
			</div>
			<div class="history-contact-refresh" v-if="!canRefresh">
				<img src="/img/loading.gif" alt="" v-if="!isEnd">
				<span v-if="!isEnd">数据加载中...</span>
				<span v-if="isEnd">{{contactList.length}}条记录</span>
			</div>
		</div>
	</div>
</template>

<script>
	import {getListByCustomWxId} from '../../network/local/cluster.js'
	import {getFansList} from '../../network/local/friend.js'
	
	export default{
		name:'HistoryContact',
		props:{
			currentCustom:{
				type: Object,
				default:function(){
					return{
						id:0,
						open_id: ''
					}
				}
			}
		},
		data(){
			return{
				lastId: 0,
				canRefresh: false,
				isEnd:false,
				activeTab:'fans',
				currentContact:{},
				contactList:[],
				keyword: ''
			}
		},
		methods:{
			// 初始数据
			init(){
				this.canRefresh = false
				this.isEnd = false
				this.lastId = 0
				this.contactList = []
			},
			
			// tab点击
			tabClick(val){
				this.activeTab = val
				this.init()
				this.showData()
			},
			
			// 列表点击
			contactClick(item){
				this.currentContact = item
				this.$emit('contact-click',item)
			},
			
			// 滚动刷新数据
			contactScroll(event){
				let page = document.getElementById("history-contact-list")
				if(page.scrollTop+page.clientHeight >= page.scrollHeight-25 && this.canRefresh){
					this.canRefresh = false
					this.showData()
				}
			},
			
			// 获取数据，并渲染列表
			showData(){
				let param = {
					keyword: this.keyword
				}
				// 获取粉丝列表
				if(this.activeTab === 'fans'){
					getFansList(this.currentCustom.id,this.lastId,param,(data)=>{
						let len = data.length
						if(len > 0){
							for(let i = 0;i<len;i++){
								let fans = data[i]
								fans.pageType = 'fans'
								this.contactList.push(fans)
							}
							this.lastId = data[len - 1].id
							this.canRefresh = true
						}else{
							this.canRefresh = false
							this.isEnd = true
						}
					})
				}
				// 获取群列表
				else{
					getListByCustomWxId(this.currentCustom.open_id,this.lastId,param,(data)=>{
						let len = data.length
						if(len > 0){
							for(let i = 0;i<len;i++){
								let fans = data[i]
								fans.pageType = 'cluster'
								this.contactList.push(fans)
							}
							this.lastId = data[len - 1].id
							this.canRefresh = true
						}else{
							this.canRefresh = false
							this.isEnd = true
						}
					})
				}
			}
		},
		
		watch:{
			currentCustom(){
				this.init()
				this.showData()
			},
			
			// 监听关键词变化
			keyword(){
				this.init()
				this.showData()
			}
		},
		
		mounted() {
			this.showData()
		}
	}
</script>

<style>
	.history-contact-container{
		width: 100%;
		height: 100%;
		overflow: hidden;
		position: relative;
	}
	.history-contact-container .history-contact-tab{
		height: 50px;
		line-height: 50px;
	}
	.history-contact-tab > span{
		display: inline-block;
		height: 50px;
		width: 50%;
		text-align: center;
		border-bottom: 1px solid #cfcfcf;
		box-sizing: border-box;
		font-weight: 600;
		cursor: pointer;
	}
	.history-contact-tab .history-contact-tab-active{
		border-bottom: #42B983 2px solid !important;
		color: #42B983;
	}
	.history-contact-container .history-contact-search{
		width: 100%;
		padding: 0 20px;
		height: 50px;
		overflow: hidden;
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
	}
	.history-contact-search .history-contact-search-input{
		width: 0;
		height: 30px;
		position: relative;
		flex-grow: 1;
		margin-right: 8px;
	}
	.history-contact-search .history-contact-search-input input{
		display: block;
		height: 30px;
		line-height: 30px;
		width: 100%;
		border: 1px solid #CFCFCF;
		border-radius: 4px;
		padding: 0 10px 0 30px;
		box-sizing: border-box;
		font-size: 12px;
	}
	.history-contact-search .history-contact-search-input input:focus{
		outline: none;
		border: 1px solid #42B983;
	}
	.history-contact-search-input .history-contact-search-icon{
		width: 30px;
		height: 32px;
		position: absolute;
		top: 0;
		left: 0;
		background-image: url(../../assets/img/c-all-search.png);
		background-size: 18px auto;
		background-repeat: no-repeat;
		background-position: center;	
	}
	.history-contact-container .history-contact-list{
		position: absolute;
		top: 100px;
		left: 0;
		right: 0;
		bottom: 5px;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.history-contact-list .history-contact-item{
		height: 40px;
		padding: 7px 20px;
		display: flex;
		justify-content: flex-start;
		cursor: pointer;
	}
	.history-contact-item:hover{
		background-color: #e3e3e3;
	}
	.history-contact-item-active{
		background-color: #e3e3e3 !important;
	}
	.history-contact-item .history-contact-avatar{
		width: 40px;
		height: 40px;
		margin-right: 10px;
	}
	.history-contact-avatar img{
		width: 100%;
		height: 100%;
		border-radius: 4px;
	}
	.history-contact-item .history-contact-info{
		width: 0;
		flex-grow: 1;
	}
	.history-contact-info p{
		height: 40px;
		line-height: 40px;
		overflow: hidden;
		color: #333333;
		display: block;
	}
	.history-contact-refresh{
		height: 36px;
		line-height: 36px;
		text-align: center;
		color: #42B983;
	}
	.history-contact-refresh > *{
		display: inline-block;
		vertical-align: middle;
	}
	.history-contact-refresh img{
		margin-right: 5px;
	}
</style>
